import * as Yup from 'yup';

const documentoValidator = (value, context) => {
  const tipoDocumento = context.parent.tipoDocumento;
  switch (tipoDocumento) {
    case 'NIF':
      return /^[0-9]{8}[A-Z]$/.test(value);
    case 'NIE':
      return /^[XYZ][0-9]{7}[A-Z]$/.test(value);
    case 'CIF':
      return /^[ABCDEFGHJPQRSUVNW][0-9]{7}[0-9A-J]$/.test(value);
    case 'CIF Admin':
      return /^[PQS][0-9]{7}[0-9A-J]$/.test(value);
    default:
      return false;
  }
};

export const terceroValidationSchema = Yup.object().shape({
  nombre: Yup.string()
    .required('El nombre es obligatorio')
    .test('is-string', 'El nombre debe ser una cadena de texto', value => typeof value === 'string'),
  tipoDocumento: Yup.string()
    .required('El tipo de documento es obligatorio')
    .matches(/^(NIF|NIE|CIF|CIF Admin)$/, 'El tipo de documento debe ser NIF, NIE, CIF o CIF Admin'),
  documento: Yup.string()
    .required('El documento es obligatorio')
    .test('validDocumento', 'Formato de documento incorrecto', documentoValidator),
  codigoPostal: Yup.string()
    .required('El código postal es obligatorio')
    .matches(/^[0-9]{5}$/, 'Código postal inválido'),
  provincia: Yup.string()
    .required('La provincia es obligatoria')
    .test('is-string', 'La provincia debe ser una cadena de texto', value => typeof value === 'string'),
  pais: Yup.string()
    .required('El país es obligatorio')
    .test('is-string', 'El país debe ser una cadena de texto', value => typeof value === 'string'),
  domicilio: Yup.string()
    .required('El domicilio es obligatorio')
    .test('is-string', 'El domicilio debe ser una cadena de texto', value => typeof value === 'string'),
  telefono: Yup.string()
    .required('El teléfono es obligatorio')
    .matches(/^(\+34|0034|34)?[6-9]\d{8}$/, 'Teléfono inválido'),
});

export const validateTerceroForm = async (formData) => {
  try {
    await terceroValidationSchema.validate(formData, { abortEarly: false });
    return {};
  } catch (error) {
    const errors = {};
    if (error.inner) {
      error.inner.forEach((err) => {
        errors[err.path] = err.message;
      });
    }
    return errors;
  }
};